import React, { Component } from "react";
import { Chart } from "react-google-charts";
import {
  Row,
  Col,
  List,
  Card,
  Collapse,
  Typography,
  Skeleton,
  Tooltip,
  Icon,
  Button,
  Alert,
  message
} from "antd";
import * as loginActions from "../../actions";
import { connect } from "react-redux";
import Moment from 'react-moment';

const { Panel } = Collapse;
const { Paragraph } = Typography;

function groupBy(arr, property) {
  return arr.reduce((memo, x) => {
    if (!memo[x[property]]) {
      memo[x[property]] = [];
    }
    memo[x[property]].push(x);
    return memo;
  }, {});
}

class GeeksForGeeks extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    if(this.props.uid){
      
      this.props.fetchSolvedProblems(
        "geeksforgeeks",
        this.props.uid
      );
    }
    
  }

  componentWillReceiveProps(props) {
   
  }

  render() {
    const userSolvedProblems = this.props.userSolvedProblems.geeksforgeeks
    const loading = userSolvedProblems && userSolvedProblems.hasOwnProperty('skeltonLoading') ? userSolvedProblems.skeltonLoading :  true;
   
    if(!loading  && userSolvedProblems.problemsList.length>0){

      var difficulty = [["Task", "Hours per Day"]];
      var o = groupBy(userSolvedProblems.problemsList, "difficulty_level");
      Object.keys(o).forEach(i => {
        difficulty.push([i, o[i].length]);
      });

    }
  
    return (
      <Skeleton active={loading} loading={loading}>
      {!loading &&  <div>
        <Row gutter={12}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Button href={"https://auth.geeksforgeeks.org/user/"+ (this.props.userName &&  this.props.userName)} target="_blank" type="dashed" style={{marginBottom:15}}>
         Goto GeeksForGeeks Profile &nbsp; <Icon type="export" />
        </Button>
          <Alert
            type="warning"
            style={{ marginBottom: 20 }}
            message={
              <>
              {userSolvedProblems && userSolvedProblems.data && userSolvedProblems.data.hasOwnProperty('timestamp') ? <><Icon type="clock-circle" /> <>Data last updated on <Moment unix>{userSolvedProblems.data.timestamp.seconds}</Moment></></> :'Profile not yet updated. Updates everyday at 6:45AM' }
              </>
            }
          ></Alert>
          <h3>{"  Problems Solved"}</h3>
          <List
                loading={loading}
                grid={{ gutter: 5, column: 3 }}
                dataSource={userSolvedProblems.problemsList}
                pagination={{
                  pageSize: 10,
                  style: { "text-align": "center" }
                }}
                renderItem={item => (
                  <List.Item>
                    <Tooltip title={item.title ? item.title : ''}>
                      <a href={item.link ? item.link : '#' } target="_blank">
                        <div
                          style={{
                            border: "1px solid #e8e8e8",
                            padding: "7px",
                            background: "#fff",
                            borderRadius: "2px",
                            transition: "all 0.3s",
                            fontSize: "16px",
                            cursor: "pointer"
                          }}
                        >
                          <Paragraph ellipsis={{ rows: 1, expandable: false }}>
                            {item.title ? item.title : ''}
                          </Paragraph>
                        </div>
                      </a>
                    </Tooltip>
                  </List.Item>
                )}
              />

          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12}>
            <Collapse accordion defaultActiveKey={["1"]}>
              <Panel header="Stats" key="1">
              {difficulty && (
                  <Chart
                    width="500px"
                    height="300px"
                    chartType="PieChart"
                    loader={<div>Loading Chart</div>}
                    data={difficulty}
                    options={{
                      is3D: true
                    }}
                    rootProps={{ "data-testid": "1" }}
                  />
                )}
              </Panel>
            </Collapse>
          </Col>
          </Row>
    </div>}
     
      </Skeleton>
      
    );
  }
}

const mapStateToProps = state => {
  // 
  // 
  return {
    userSolvedProblems: state.auth.userSolvedProblems
  };
};

const mapDispachToProps = (dispatch, props) => ({
  fetchSolvedProblems: (websiteName, UID, setLoading) => {
    // 
    dispatch(loginActions.fetchSolvedProblems(websiteName, UID, setLoading));
  }
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(GeeksForGeeks);
